import { render } from "./StripeLink.vue?vue&type=template&id=471b5245"
import script from "./StripeLink.vue?vue&type=script&lang=js"
export * from "./StripeLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__